import { useCallback } from 'react';

import { buildURL } from '../util/url';

export const useURLBuilder = (base: string) => {
	return useCallback(
		(...paths: (string | number)[]) => {
			return buildURL(base)(...paths);
		},
		[base]
	);
};
